import React from 'react';
import TextBubbles from '@/pages/home/components/TextBubbles';
import './index.less';
import { ITextNodeProps } from './type';

const TextNode = (props: ITextNodeProps) => {
  const { dataConfig } = props || {};
  const { icon, name, valueShow, percent, depth, hidePercent, longestNameWidth, valueWidth = 200 } = dataConfig || {};

  return (<>
    <div className='dbd-tree-box-text-box'>
      <div className='dbd-tree-box-text-box-right'>
        {
          icon && <div className='dbd-tree-box-text-box-img'>
            <img className='dbd-country-icon' src={icon} alt="flag" />
          </div>
        }
        {/* event.stopPropagation() 主要是阻止TextBubbles的点击事件冒泡到了父级的节点收起展开上面，此处为了实现TextBubbles打开了dbd-tree-box-text-name的point事件 */}
        <div className='dbd-tree-box-text-box-name'   style={{ width: `${longestNameWidth + 22}px` }} onClick={(event) => event.stopPropagation()}>
          <TextBubbles className="dbd-tree-box-text-name" text={name || '-'} />
        </div>
      </div>
      <div className='dbd-tree-box-text-box-value'  style={{ width: depth !== 1 ? valueWidth + 22 : 120, marginLeft: depth !== 1 ? 0 : 6}}>
        {/* 注意空格不能删，用来占位 */}
        {valueShow}{(depth !== 1 && !hidePercent) && `  (${valueShow < 0 ? "-" : ""}${ percent}) `}
      </div>
    </div>
  </>);
};

export default TextNode;